import classNames from 'classnames';
import { FC } from 'react';
import { Link } from 'react-router-dom';

import { IMainCatalogChild } from '../../shared/types/main-catalog';

interface ICatalogMenuItem {
  child: IMainCatalogChild;
  openCategory: string;
  tooltipIsOpen: IMainCatalogChild;
  handleClose: () => void;
}

// Элемент каталога
const CatalogMenuItem: FC<ICatalogMenuItem> = ({
  child,
  handleClose,
  openCategory,
  tooltipIsOpen,
}) => {
  return (
    <li
      key={child?.id}
      onClick={handleClose}
      className={classNames('catalog-menu__child', openCategory)}
    >
      <Link
        to={`/${openCategory === 'equipments' ? 'equipment' : openCategory}/${
          child?.slug
        }`}
        className="catalog-menu__subtitle custom"
      >
        {child?.title}
      </Link>
      {child?.children.length !== 0 && (
        <ul
          className={classNames('catalog-menu__inner', {
            custom: tooltipIsOpen.id === 637 || tooltipIsOpen.id === 742,
          })}
        >
          {child?.children?.map((item: any) => {
            return (
              <li onClick={handleClose} key={item?.id}>
                <Link
                  to={`/${
                    openCategory === 'equipments' ? 'equipment' : openCategory
                  }/${item?.slug}`}
                >
                  {item?.title}
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </li>
  );
};

export default CatalogMenuItem;
